import clsx from 'clsx';
import { useMemo, type ReactNode } from 'react';

export function SectionTitle(
    { text, color, className }: { text: string | ReactNode; color: string; className?: string },
) {
    const colorClassName = useMemo(() => {
        switch (color) {
            case 'blue':
                return 'text-crispybluedark-700';
            case 'white':
                return 'text-white';
            default:
                return 'text-black';
        }
    }, [ color ]);

    return <h1 className={clsx('text-4xl font-bold mb-10', colorClassName, className)}>{text}</h1>;
}
